import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Col } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation } from 'react-router-dom';
import Loader from '../../../../../Components/Utility/Loader/Loader';
import SampleImg from '../SampleImg';
import * as action from '../../../store/DevelopmentOrder.action';
import ConfirmationPopup from '../../../../../Components/ModalPopup/ConfirmationPopup';
import SupplierImagedrope from '../../../../../Components/ImgDropzone/supplierImagedrope';
import DragDropSort from '../../../../../Components/DragDropSort/DragDropSort';
import { useComponent } from '../../../../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../../../../Components/Tooltip/CustomTooltip';

function SupplierImages({ show, handleUpdateImageData, toggle }) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const [deleteImageId, setDeleteImageId] = useState({});
  const devOrderReducer = useSelector((reducerstate) => reducerstate);
  const {
    Measuremets,
    Users,
    BOMConfigDetails: { isProductArchived },
  } = devOrderReducer;

  const { sampleDetails, sampleAnnotationImage } = Measuremets;
  const { devOrderId } = useParams();
  const { logInRights } = Users;
  const { CheckActionPermission } = useComponent();
  const SampleEditAccess = CheckActionPermission(logInRights, 'products', 'samples', 'addEdit');
  const SampleDeleteAccess = CheckActionPermission(logInRights, 'products', 'samples', 'delete');
  const SampleAllAccess = CheckActionPermission(logInRights, 'products', 'samples', 'all');

  const queryParams = useLocation();
  const { search } = queryParams;
  const smapleId = new URLSearchParams(search).get('sample');

  const childRef = useRef();
  const [supplierImageData, setSupplierImageData] = useState([]);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [replaceShow, setReplaceShow] = useState(false);
  const [itemList, setitemList] = useState([]);
  const [showDragDrop, setShowDragDrop] = useState(false);
  const [parentIndex, setParentIndex] = useState(null);
  const [replaceItem, setReplaceItem] = useState(null);
  const [sampleImageId, setSampleImageId] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const [sizeRange, setSizeRange] = useState([]);
  const [state, setState] = useState({
    imageUploading: false,
  });
  const { imageUploading } = state;
  const customStyles = {
    option: (provided) => ({
      ...provided,
      padding: '5px 10px',
    }),
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '35px',
      borderBottom: '1px solid #848484',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.7 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    },
    menu: (provided) => ({
      ...provided,
      margin: '-1px 0 0 0',
      border: '1px solid #848484',
      borderRadius: 0,
      fontSize: 14,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
      color: '#555',
      fontFamily: 'Aktiv Grotesk, sans-serif !important',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#848484',
      fontSize: 14,
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#aaa', // Custom colour
      padding: '8px 2px',
      svg: {
        width: '22px',
        height: '22px',
      },
    }),
  };
  useEffect(() => {
    const values = [];
    if (sampleDetails?.gradingGroupData && sampleDetails?.gradingGroupData?.length > 0) {
      sampleDetails?.gradingGroupData?.map((ele) => {
        const length = ele?.len?.name;
        const size = ele?.size;
        const quan = ele?.quantity ? `(${ele?.quantity})` : ' ';
        let value = {};

        if (size) {
          if (length)
            value = {
              value: ele._id,
              label: ` ${size}, ${length} ${quan} `,
              size,
            };
          if (length)
            value = {
              value: ele._id,
              label: `${size}, ${length} ${quan}`,
              size,
            };
          if (!length)
            value = {
              value: ele._id,
              label: ` ${size} ${quan}`,
              size,
            };
          if (!length) value = { value: ele._id, label: `${size} ${quan}`, size };
          values.push(value);
        }
      });
    }

    values?.sort((a, b) => a?.label?.localeCompare(b?.label));
    setSizeRange(values);
  }, [sampleDetails]);

  const replaceImageSubmit = async (data) => {
    const imageData = {
      image: data[0].image,
      sampleId: smapleId,
      parentIndex,
      supplierImgId: sampleImageId,
      devOrderId,
    };
    setState((prev) => ({
      ...prev,
      imageUploading: true,
    }));
    await dispatch(action.replaceSupplierImage(imageData, t));
    setState((prev) => ({
      ...prev,
      imageUploading: false,
    }));
    getSupplierImage();
    if (data && replaceShow === true) {
      setReplaceShow(false);
    }
  };

  const replaceImage = (e, item, index) => {
    e.preventDefault();

    setParentIndex(index);
    setSampleImageId(item._id);
    setReplaceItem(item);
    setReplaceShow(!replaceShow);
  };

  const handleImageUpload = async (data) => {
    if (data === 'close' && replaceShow === false) {
      toggle();
      return;
    }
    if (data === 'close' && replaceShow === true) {
      setReplaceShow(false);
      return;
    }

    if (replaceShow === true) {
      return replaceImageSubmit(data);
    }

    const params = {
      devOrderId,
      sampleId: smapleId,
    };

    const imageData = {
      annotaeImage: data,
      isSupplierImages: true,
    };

    if (data) {
      setState((prev) => ({
        ...prev,
        imageUploading: true,
      }));
      await dispatch(action.setSampleAnnotations(params, imageData, t));
      toggle();
      getSupplierImage();
      setState((prev) => ({
        ...prev,
        imageUploading: false,
      }));
    }
  };

  const handleDeleteModal = () => {
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const getSupplierImage = async (id) => {
    setIsLoader(true);
    const params = {
      devOrderId,
      sampleId: smapleId,
    };
    await dispatch(action.getSampleAnnotations(params));
    setIsLoader(false);
  };

  const deleteSampleImage = async () => {
    await dispatch(action.deleteSampleAnnotations(devOrderId, smapleId, deleteImageId, t));
    setShowConfirmationPopup(!showConfirmationPopup);
    getSupplierImage();
  };

  const reArrangeDocPosition = async (e, index) => {
    e.preventDefault();
    const itemslistData = sampleAnnotationImage?.supplierImages[index];
    itemslistData.map((ele) => {
      ele.parentIndex = index;
    });
    await setitemList(itemslistData);
    setShowDragDrop(!showDragDrop);
  };

  const hideShowDragDrop = () => {
    setShowDragDrop(!showDragDrop);
  };

  const handleSaveSequence = async (_e, sequenceList) => {
    const sampleId = sequenceList?.sequence[0].sampleId;
    const parentIndex = sequenceList?.sequence[0].parentIndex;
    const supplierImages = sequenceList?.sequence.map((e) => {
      delete e.sampleId;
      delete e.parentIndex;
      return e;
    });
    const params = {
      sampleId,
      parentIndex,
      supplierImages,
    };

    await action.saveSupplierImagesSequence(params, t);
    getSupplierImage();
    hideShowDragDrop();
  };

  const verticalList = (item, i, index) => {
    return (
      <div className="card-container" key={`${item.image}_${i}_${index}`}>
        <div className="image-header">
          <div className="flex-fill mr-1">
            <Select
              options={sizeRange}
              getOptionLabel={({ label }) => label}
              getOptionValue={({ value }) => value}
              styles={customStyles}
              className="common-select"
              classNamePrefix="common-select"
              name="samples"
              value={item.specification}
              onChange={(val) => {
                handleUpdateImageData(val, 'specification', i, index);
              }}
              placeholder={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_IMAGE.SELECT_SIZE')}
              menuPosition="fixed"
              menuShouldBlockScroll
              menuShouldScrollIntoView
              isDisabled={(!SampleEditAccess && !SampleAllAccess) || isProductArchived}
            />{' '}
          </div>

          {SampleEditAccess && (
            <>
              <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_IMAGE.REARRANGE')}>
                <button
                  type="button"
                  className="btn btn-outline d-none d-md-flex m-0 mr-1"
                  aria-label="Rearrange"
                  onClick={(e) => reArrangeDocPosition(e, index)}
                  disabled={isProductArchived}
                >
                  <i className="icon-Rearrange f-22" />
                </button>
              </CustomTooltip>
              <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_IMAGE.REPLACES')}>
                <button
                  type="button"
                  aria-label="Replace"
                  className="btn btn-outline m-0 mr-1"
                  onClick={(e) => replaceImage(e, item, index)}
                  disabled={isProductArchived}
                >
                  <i className="icon-Replace f-24" />
                </button>
              </CustomTooltip>
            </>
          )}
          {(SampleDeleteAccess || SampleAllAccess) && (
            <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_IMAGE.DELETE')}>
              <button
                type="button"
                disabled={isProductArchived}
                aria-label="Delete"
                onClick={() => {
                  setDeleteImageId({
                    designImageId: item._id,
                    image: item?.image,
                    isSupplierImages: true,
                    parentIndex: index,
                    title: item?.name || '',
                  });
                  setShowConfirmationPopup(true);
                }}
                className="btn btn-outline m-0"
              >
                <span className="icon-Delete f-24" />
              </button>
            </CustomTooltip>
          )}
        </div>
        <div className="image-card">
          <div className="flex-fill">
            <input
              name="Name"
              className="form-control text-bordered  border-bottom"
              type="text"
              placeholder="Enter Name"
              value={item.name}
              onChange={(e) => {
                handleUpdateImageData(e.target.value, 'name', i, index);
              }}
              disabled={(!SampleEditAccess && !SampleAllAccess) || isProductArchived}
            />
          </div>
          <div className="d-md-none">
            <SampleImg src={item.image} />
          </div>
          <div className="d-none d-md-block">
            <SampleImg src={item.image} zoomClass="magnifier-zoom-container" />
          </div>
        </div>
      </div>
    );
  };

  const horizontalList = (item, i, index) => {
    return (
      <div className="card-container-hor" key={`${item.image}_${i}_${index}`}>
        <div className="image-header">
          <div className="flex-fill  mr-1">
            <Select
              options={sizeRange}
              getOptionLabel={({ label }) => label}
              getOptionValue={({ value }) => value}
              styles={customStyles}
              className="common-select"
              classNamePrefix="common-select"
              name="samples"
              value={item.specification}
              onChange={(val) => {
                handleUpdateImageData(val, 'specification', i, index);
              }}
              placeholder={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_IMAGE.SELECT_SIZE')}
              isDisabled={(!SampleEditAccess && !SampleAllAccess) || isProductArchived}
            />
          </div>

          {SampleEditAccess && (
            <>
              <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_IMAGE.REARRANGE')}>
                <button
                  type="button"
                  className="btn btn-outline d-none d-md-flex m-0 mr-1"
                  aria-label="Rearrange"
                  onClick={(e) => reArrangeDocPosition(e, index)}
                  disabled={isProductArchived}
                >
                  <i className="icon-Rearrange f-22" />
                </button>
              </CustomTooltip>
              <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_IMAGE.REPLACE')}>
                <button
                  type="button"
                  className="btn btn-outline m-0 mr-1"
                  aria-label="Replace"
                  onClick={(e) => replaceImage(e, item, index)}
                  disabled={isProductArchived}
                >
                  <i className="icon-Replace f-24" />
                </button>
              </CustomTooltip>
            </>
          )}
          {SampleDeleteAccess && (
            <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_IMAGE.DELETES')}>
              <button
                type="button"
                aria-label="Delete"
                onClick={() => {
                  setDeleteImageId({
                    designImageId: item._id,
                    image: item?.image,
                    isSupplierImages: true,
                    parentIndex: index,
                    title: item?.name || '',
                  });
                  setShowConfirmationPopup(true);
                }}
                disabled={isProductArchived}
                className="btn btn-outline m-0 "
              >
                <span className="icon-Delete f-24" />
              </button>
            </CustomTooltip>
          )}
        </div>

        <div className="image-card-hor">
          <div className="flex-fill">
            <input
              name="Name"
              className="form-control text-bordered border-bottom"
              type="text"
              placeholder="Enter Name"
              value={item.name}
              onChange={(e) => {
                handleUpdateImageData(e.target.value, 'name', i, index);
              }}
              disabled={(!SampleEditAccess && !SampleAllAccess) || isProductArchived}
            />
          </div>
          <div className="d-md-none">
            <SampleImg src={item.image} />
          </div>
          <div className="d-none d-md-block">
            <SampleImg src={item.image} zoomClass="magnifier-zoom-container-horizontal" />
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    getSupplierImage();
  }, []);

  useEffect(() => {
    sampleAnnotationImage?.sampleAnnotateImages && setSupplierImageData(sampleAnnotationImage?.supplierImages);
  }, [sampleAnnotationImage]);

  return (
    <>
      {isLoader ? (
        <Loader />
      ) : (
        <div className="container-list">
          <div>
            {supplierImageData?.length > 0 ? (
              supplierImageData?.map((ele, index) => {
                return ele.length ? (
                  <div key={`${ele?._id}_${index}`} className="card-list_container">
                    {ele.map((item, i) => {
                      return item.isVertical === true ? verticalList(item, i, index) : horizontalList(item, i, index);
                    })}
                  </div>
                ) : (
                  ''
                );
              })
            ) : (
              <Col md={12}>
                <div className=" my-4 py-4">
                  <p className="text-center">{t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_IMAGE.NO_SUPLIER_IMAGE_FOUND')}</p>
                </div>
              </Col>
            )}
          </div>
        </div>
      )}

      {show && <ImgUpload show={show} toggle={toggle} childRef={childRef} handleImageUpload={handleImageUpload} imageUploading={imageUploading} />}

      {replaceShow && (
        <ImgUpload
          show={replaceShow}
          toggle={() => setReplaceShow(false)}
          childRef={childRef}
          handleImageUpload={handleImageUpload}
          replaceItem={replaceItem}
          fromRelace={replaceShow}
          imageUploading={imageUploading}
        />
      )}

      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteSampleImage}
          message={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_IMAGE.DELETE_SAMPLE_MESSAGE')}
          title={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_IMAGE.DELETES')}
          toggle={handleDeleteModal}
        />
      )}

      {showDragDrop && (
        <DragDropSort
          devOrderId={devOrderId}
          itemList={itemList?.map((ele, i) => {
            ele._id = i;
            ele.sampleId = sampleAnnotationImage?.sampleId;
            return ele;
          })}
          isShow={showDragDrop}
          isToggle={hideShowDragDrop}
          saveSequence={handleSaveSequence}
          fromComp="supplierImagesItems"
        />
      )}
    </>
  );
}

function ImgUpload({ show, childRef, fromRelace, replaceItem, handleImageUpload, sampleImage, imageUploading, toggle }) {
  const { t } = useTranslation('common');

  return (
    <Modal className="common-custom-modal" size="xl" show={show} onHide={toggle} backdrop="static">
      <Modal.Header>
        <Modal.Title> {t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_IMAGE.UPLOAD_IMAGE')}</Modal.Title>
        <span onClick={toggle} className="icon-close cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        {false ? (
          <Loader />
        ) : (
          <form>
            <SupplierImagedrope
              ref={childRef}
              onSubmit={handleImageUpload}
              acceptedFileExtenstion=".jpeg,.jpg,.png"
              sampleImage={sampleImage}
              image=""
              isEditMode
              cropSize="4/4"
              replaceItem={replaceItem}
              fromRelace={fromRelace}
              loading={imageUploading}
            />
          </form>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default SupplierImages;
